/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export enum MessageType {
	ERROR = 'ERROR',
	INFO = 'INFO'
}
